import MotionWrapper from '@atoms/MotionWrapper/MotionWrapper';
import classNames from 'classnames';
import { AnimatePresence } from 'framer-motion';

interface Props {
  readonly title?: string;
  readonly text?: string;
  readonly open?: boolean;
  readonly dataTestId?: string;
}

const CollapsibleTextSection = ({
  title,
  text,
  open = true,
  dataTestId = 'Collapsible-Text-Section',
}: Props) => (
  <>
    {title && (
      <p className="h4 w-full" data-testid={`${dataTestId}-Title`}>
        {title}
      </p>
    )}
    {text && (
      <AnimatePresence>
        {open && (
          <MotionWrapper
            style={{ overflow: 'hidden' }}
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
          >
            <p
              className={classNames(
                { 'mt-10 lg:mt-15': title },
                'body-one whitespace-pre-line text-black-100 dark:text-grey-400'
              )}
              data-testid={`${dataTestId}-Text`}
            >
              {text}
            </p>
          </MotionWrapper>
        )}
      </AnimatePresence>
    )}
  </>
);

export default CollapsibleTextSection;
